/**
 * `#download` — bản tiếng Anh. Hình dạng phải khớp `vi/download.ts`; lệch một khoá là lỗi biên dịch.
 */
interface DownloadHighlight {
  readonly icon: 'bell' | 'panel-right' | 'lock';
  readonly text: string;
}

interface DownloadMockMessage {
  readonly initials: string;
  readonly tint: 'brand' | 'warn';
  readonly text: string;
}

interface DownloadPlatform {
  /** Dòng nhỏ phía trên tên nền tảng trong nút. */
  readonly overline: string;
  readonly name: string;
  readonly requirement: string;
  readonly fileType: string;
  /** Lệnh tính SHA-256 trên chính hệ điều hành đó, cho tệp vừa tải về thư mục Downloads. */
  readonly verifyCommand: string;
}

export const download = {
  eyebrow: 'Desktop app',
  heading: 'Nexa on your computer',
  lead: 'Install Nexa for macOS or Windows to open your workspace in one click, get notifications right on your screen, and work in a window of its own, away from dozens of browser tabs.',
  highlights: [
    { icon: 'bell', text: 'Desktop notifications, even when the window is minimised' },
    { icon: 'panel-right', text: 'A window of its own, never lost among browser tabs' },
    { icon: 'lock', text: 'Same account, data in sync with the web app' },
  ] as readonly DownloadHighlight[],
  platforms: {
    mac: {
      overline: 'Download for',
      name: 'macOS',
      requirement: 'Apple silicon (M1 or later)',
      fileType: '.dmg',
      verifyCommand: 'shasum -a 256 ~/Downloads/nexa-*.dmg',
    },
    windows: {
      overline: 'Download for',
      name: 'Windows',
      requirement: 'Windows 64-bit (x64)',
      fileType: '.exe',
      verifyCommand: '(Get-FileHash $HOME\\Downloads\\nexa-*.exe).Hash.ToLower()',
    },
  } satisfies Record<'mac' | 'windows', DownloadPlatform>,
  recommended: 'Your device',
  intelNote: 'Intel-based Macs are not supported yet.',
  checksumToggle: 'Verify file integrity (SHA-256)',
  checksumHint:
    'Open the SHA-256 file for the build you downloaded, then run the command below: both strings must match.',
  checksumLink: 'View SHA-256',
  webPrompt: 'Rather not install anything?',
  webLink: 'Use Nexa in your browser',
  mock: {
    channel: 'design-system',
    composer: 'Message #design-system',
    notificationApp: 'Nexa',
    notificationTime: 'now',
    notificationTitle: 'Maya C. · #design-system',
    notificationBody: 'Could you review the v2 tokens before 3 PM?',
    messages: [
      { initials: 'MC', tint: 'warn', text: 'The v2 tokens are done, please take a look.' },
      { initials: 'JP', tint: 'brand', text: "I'll open a topic so feedback stays tidy." },
    ] as readonly DownloadMockMessage[],
  },
};
